import { render, staticRenderFns } from "./BasePrice.vue?vue&type=template&id=01d90fd0"
import script from "./BasePrice.vue?vue&type=script&lang=js"
export * from "./BasePrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports